import { render } from "./RestrictedAccessPopup.vue?vue&type=template&id=c6df548e&scoped=true"
import script from "./RestrictedAccessPopup.vue?vue&type=script&lang=js"
export * from "./RestrictedAccessPopup.vue?vue&type=script&lang=js"

import "./RestrictedAccessPopup.vue?vue&type=style&index=0&id=c6df548e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6df548e"]])

export default __exports__